const META_MARKER = '<<<GGJ_RESUME_META_V1>>>';
const BODY_MARKER = '<<<GGJ_RESUME_BODY>>>';

export type SavedProfileDesign = { font: string; color: string; caps: string };

export type SavedProfileMetaV1 = {
  v: 1;
  templateId: string;
  design?: SavedProfileDesign;
};

/** Wrap resume body + template metadata for candidate profile `.txt` storage. */
export function serializeSavedProfileResumeFile(
  meta: { templateId: string; design?: SavedProfileDesign },
  body: string
): string {
  const header: SavedProfileMetaV1 = {
    v: 1,
    templateId: meta.templateId,
    ...(meta.design ? { design: meta.design } : {}),
  };
  return `${META_MARKER}\n${JSON.stringify(header)}\n${BODY_MARKER}\n${body}`;
}

/** Parse profile file; legacy plain text returns full raw as body with default template. */
export function parseSavedProfileResumeFile(raw: string): {
  body: string;
  templateId: string;
  design?: SavedProfileDesign;
} {
  const cleaned = raw.replace(/^\uFEFF/, '');
  if (!cleaned.includes(BODY_MARKER)) {
    return { body: cleaned, templateId: 'ats-optimized' };
  }
  const parts = cleaned.split(BODY_MARKER);
  const afterBody = parts.slice(1).join(BODY_MARKER).replace(/^\r?\n/, '');
  const head = parts[0] ?? '';
  let templateId = 'ats-optimized';
  let design: SavedProfileDesign | undefined;
  if (head.includes(META_MARKER)) {
    const metaJson = head.split(META_MARKER)[1]?.trim() ?? '';
    try {
      const parsed = JSON.parse(metaJson) as Partial<SavedProfileMetaV1>;
      if (parsed.templateId && typeof parsed.templateId === 'string') {
        templateId = parsed.templateId;
      }
      if (parsed.design && typeof parsed.design === 'object') {
        design = {
          font: String(parsed.design.font ?? 'default'),
          color: String(parsed.design.color ?? ''),
          caps: String(parsed.design.caps ?? 'none'),
        };
      }
    } catch {
      /* keep defaults */
    }
  }
  return { body: afterBody, templateId, design };
}
